<template>
  <v-sheet>
    <div class="d-flex justify-center pa-2">
      <v-btn icon @click="$router.go(-1)"
        ><v-icon color="black" large>mdi-arrow-left</v-icon></v-btn
      >
      <v-card
        max-width="70%"
        class="mx-auto mt-2 elevation-10"
        height="auto"
        width="70%"
      >
        <!--<v-overlay v-model="loading">
          <v-progress-circular
            :size="100"
            :width="7"
            color="pink darken-4"
            indeterminate
          />
        </v-overlay>-->
        <v-container>
          <v-row v-if="$vuetify.breakpoint.smAndDown">
            <v-col class="d-flex justify-end ma-0 pa-0 px-2">
              <v-btn
                icon
                v-show="salvar"
                @click.stop="dialog = true"
                class="mr-4 my-4"
              >
                <v-icon x-large color="#4B2A66">mdi-bookmark-outline</v-icon>
              </v-btn>

              <v-btn
                icon
                v-show="salvo"
                @click="(salvar = true), (salvo = false), deleteSaved()"
              >
                <v-icon x-large color="#4B2A66">mdi-bookmark</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-row justify="space-between">
            <v-col cols="12" md="6">
              <v-sheet
                class="mx-auto d-flex align-end"
                max-width="100%"
                height="100%"
                color="transparent"
                ><v-carousel v-model="model">
                  <v-carousel-item v-for="i in product.images.length" :key="i">
                    <v-sheet color="transparent" tile>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                      >
                        <div class="display-3">
                          <v-img
                            :src="product.images[i - 1]"
                            color="pink darken-4"
                          />
                        </div>
                      </v-row>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
              </v-sheet>
            </v-col>

            <v-col cols="12" md="6" class="text-center pl-0">
              <v-row v-if="$vuetify.breakpoint.mdAndUp">
                <v-col class="d-flex justify-start ma-2 pa-0 px-2">
                  <div class="text-h5 blue--text">
                    {{ product.product }}
                  </div>
                </v-col>
                <v-col class="d-flex justify-end">
                  <v-btn icon v-show="salvar" @click.stop="dialog = true">
                    <v-icon x-large color="#4B2A66"
                      >mdi-bookmark-outline</v-icon
                    >
                  </v-btn>

                  <v-btn
                    icon
                    v-show="salvo"
                    @click="deleteSaved(), (salvar = true), (salvo = false)"
                  >
                    <v-icon x-large color="#4B2A66">mdi-bookmark</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-col class="d-flex justify-start ma-0 pa-0 px-2">
                <div class="text-subtitle-1" v-if="product.category">
                  Categoria: {{ product.category }}
                </div>
              </v-col>
              <v-col class="d-flex justify-start ma-0 pa-0 px-2">
                <div class="text-subtitle-1" v-if="product.description">
                  Descrição: {{ product.description }}
                </div>
              </v-col>

              <v-col class="d-flex justify-start ma-0 pa-0 px-2">
                <div class="text-h6">Valor: R${{ product.value }}</div>
              </v-col>
              <v-col
                v-if="product.promotional_value"
                class="d-flex justify-start ma-0 pa-0 px-2"
              >
                <v-text class="text-h6 red--text">
                  Valor Promocional: R${{ product.promotional_value }}
                </v-text>
              </v-col>

              <v-divider />

              <v-col class="d-flex justify-start ma-2 pa-0 mb-4">
                <v-avatar>
                  <v-img :src="shop.photograph" />
                </v-avatar>
                <v-list-item class="ml-2 text-h6" @click="openShop()">{{
                  shop.shop_name
                }}</v-list-item>
              </v-col>
              <div class="text-subtitle-2 mt-1" style="color: #4b2a66">
                Localização:
              </div>
              <div v-if="shop.street && shop.number && shop.neighborhood">
                R.{{ shop.street }}, {{ shop.number }} - {{ shop.neighborhood }}
              </div>
              <div>{{ city.name }} - {{ state }}</div>
              <p></p>
              <v-card v-show="false">
                <v-img src="@/assets/google_maps.jpg" height="150px" />
              </v-card>
              <v-col>
                <v-btn
                  v-if="shop.facebook_link"
                  icon
                  class="ma-1"
                  target="_blank"
                  :href="$utils.processURL(shop.facebook_link)"
                >
                  <v-icon size="30" color="blue">mdi-facebook</v-icon>
                </v-btn>
                <v-btn
                  v-if="shop.instagram_link"
                  icon
                  class="ma-1"
                  target="_blank"
                  :href="$utils.processURL(shop.instagram_link)"
                >
                  <v-icon size="30" color="pink">mdi-instagram</v-icon>
                </v-btn>
                <v-btn
                  v-if="shop.whatsapp_link"
                  icon
                  class="ma-1"
                  target="_blank"
                  :href="$utils.processWhatsapp(shop.whatsapp_link)"
                >
                  <v-icon size="30" color="green">mdi-whatsapp</v-icon>
                </v-btn>
                <v-btn
                  v-if="shop.telephone"
                  icon
                  class="ma-1"
                  target="_blank"
                  :href="$utils.processWhatsapp(shop.telephone)"
                >
                  <v-icon size="30">mdi-phone</v-icon>
                </v-btn>
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>

    <v-container style="max-width: 100%">
      <div max-width="100%">
        <v-container fluid>
          <v-row dense>
            <v-col v-for="product in products" :key="product._id">
              <v-card @click="openProduct(product.url_product)">
                <v-img
                  :src="
                    product.images.length == 0 ? undefined : product.images[0]
                  "
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="250px"
                >
                  <v-card-title class="ma-0 pa-0 pl-2">
                    {{ product.product }}
                  </v-card-title>

                  <v-card-actions class="ma-0 pa-0">
                    <v-card-title class="text-button ma-1 pa-0">
                      R$ {{ product.value }}
                    </v-card-title>

                    <v-spacer />
                  </v-card-actions>
                </v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-container>

    <v-dialog v-model="dialog" max-width="500">
      <v-card class="text-center pa-2">
        <div class="text-h6 pl-4 pt-3">Deseja salvar essa essa postagem?</div>

        <!-- <v-col cols="12">
          <v-textarea
            class="pt-3"
            label="Envie mensagem para o lojista"
            placeholder="Escreva sua mensagem aqui"
            outlined
            dark
          ></v-textarea>
        </v-col>-->

        <v-checkbox
          v-model="save.share"
          class="mx-4"
          label="Aceito receber mensagens do lojista dessa postagem"
          hide-details
        ></v-checkbox>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="#4B2A66"
            text
            @click="
              saved(product._id),
                (dialog = false),
                (salvar = false),
                (salvo = true)
            "
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
export default {
  data: () => ({
    loading: true,
    dialog: false,
    product: {
      images: [],
    },
    products: [],
    salvar: true,
    salvo: false,
    shop: [],
    name_shop: "",
    id_city: "",
    state: "",
    city: [],
    productSave: [],
    newSaved: "",
    saved_id: "",
    save: {
      product_id: "",
      shop_id: "",
      share: false,
    },
    items: [
      {
        color: "#952175",
        src: "https://picsum.photos/500/300?random",
        title: "Name",
        artist: "Breve Descrição",
      },
    ],
  }),
  methods: {
    openShop() {
      this.$router.replace({
        path: "/negocio/" + this.$route.params.shop_url,
      });
    },
    openProduct(url_product) {
      this.url_product = url_product;
      this.salvar = true;
      this.salvo = false;
      this.$router.replace({
        path: this.url_product,
      });
      this.$axios
        .get("/product/" + this.shop.id + "/" + this.$route.params.product_url)
        .then((response) => {
          this.product = response.data;
          this.product_id = response.data._id;
          this.loading = false;
          window.scroll(0, 0);
          this.$axios.get("saved").then((response) => {
            this.productSave = response.data;
            this.productSave.forEach((savedProduct, i) => {
              if (savedProduct.url_product == this.$route.params.product_url) {
                this.saved_id = this.productSave[i]._id;
                this.salvar = false;
                this.salvo = true;
              }
            });
          });
        });
    },
    saved(product_id) {
      this.save.product_id = product_id;
      this.$axios.post("/saved", this.save).then((response) => {
        this.newSaved = response.data;
      });
    },
    deleteSaved() {
      this.$axios
        .delete("/saved/" + this.saved_id + "/" + this.product._id)
        .then((response) => {
          this.deletedProduct = response.data;
          this.salvar = true;
          this.salvo = false;
        });
    },
  },
  mounted() {
    this.$axios.get("/shop/" + this.$route.params.shop_url).then((response) => {
      this.shop = response.data;
      this.shop_id = response.data.id;
      this.save.shop_id = response.data.id;
      this.name_shop = response.data.shop_name;
      this.id_city = response.data.city_id;
      this.$axios.get("/products/" + this.shop_id).then((response) => {
        this.products = response.data;
        document.title = `Olhadela - ${this.shop.shop_name} - ${this.product.name}`;
        this.productSave.forEach((savedProduct, i) => {
          if (savedProduct.url_product == this.$route.params.product_url) {
            this.saved_id = this.productSave[i]._id;
            this.salvar = false;
            this.salvo = true;
          }
        });
      });
      this.$axios.get("/city/" + this.id_city).then((response) => {
        this.city = response.data;
        this.$axios.get("/state/" + response.data.state_id).then((response) => {
          this.state = response.data.uf;
        });
      });
      this.$axios
        .get("/product/" + this.shop.id + "/" + this.$route.params.product_url)
        .then((response) => {
          this.product = response.data;
          this.loading = false;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 404) {
              this.$router.replace({
                path: "/error404",
              });
            }
          }
        });
    });
    this.$axios.get("saved").then((response) => {
      this.productSave = response.data;
    });
  },
  watch: {
    newSaved: function () {
      this.$axios.get("/products/" + this.shop_id).then((response) => {
        this.products = response.data;
        this.productSave.forEach((savedProduct, i) => {
          if (savedProduct.url_product == this.$route.params.product_url) {
            this.saved_id = this.productSave[i]._id;
            this.salvar = false;
            this.salvo = true;
          }
        });
      });
      this.$axios.get("saved").then((response) => {
        this.productSave = response.data;
      });
    },
  },
};
</script>
